export class ElementShaker {
    public static shake(element: HTMLElement, times: number) {
        if (times > 0) {
            setTimeout(() => {
                const degrees = (times % 2) === 0 ? -1 : 1;
                element.style.transform = `rotate(${degrees}deg)`;
                this.shake(element, times - 1);
            }, 50);
        }
        else {
            element.style.transform = "rotate(0deg)";
        }
    }
}
